import React from "react";
import useTaskField from "@dyl/pages/Tasks/edit/useTaskField";
import ImagePicker from "@dyl/components/ImagePicker";
import { Grid, TextField, Typography } from "@mui/material";
import useChangeEvent from "@dyl/hooks/useChangeEvent";


export default function StoryEditor({ index, ...other }) {
    const [answers] = useTaskField('items', index, 'answers');
    const [imageId, setImageId, imageError] = useTaskField('items', index, 'image_id');

    return (
        <>
            {imageId !== undefined && imageId != null &&
                <ImagePicker
                    label='Cell Image'
                    value={imageId ?? ''}
                    onChange={setImageId}
                    helperText={imageError}
                    error={!!imageError}
                />
            }

            <Grid style={{ marginTop: 16, marginBottom: 16, }}/>

            {answers.length > 0 &&
                <Grid container>
                    <Typography variant={'body1'}>Dictionary</Typography>
                    <Grid container columnSpacing={2} justifyContent={'center'}>
                        {answers.map((a, i) => <Answer key={i} itemIndex={index} answerIndex={i}/>)}
                    </Grid>
                </Grid>
            }
        </>
    );
}

function Answer({ itemIndex, answerIndex }) {
    const [label, setLabel, labelError] = useTaskField('items', itemIndex, 'answers', answerIndex, 'label');
    const [imageId, setImageId, imageIdError] = useTaskField('items', itemIndex, 'answers', answerIndex, 'image_id');
    const onLabelChange = useChangeEvent(setLabel);

    return (
        <Grid item md={4} sm={6} xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
            <ImagePicker
                fullWidth
                value={imageId}
                onChange={setImageId}
                error={!!imageIdError}
                label={`Image ${answerIndex + 1}`}
            />

            <Grid style={{ marginTop: 4, marginBottom: 6, }}/>

            <TextField
                style={{ maxWidth: '320px' }}
                label={`Label ${answerIndex + 1}`}
                value={label}
                onChange={onLabelChange}
                variant='filled'
                error={!!labelError}
                helperText={labelError ?? 'The dictionary word accompanying paired image'}
            />
        </Grid>
    );
}